import React, { useEffect, useMemo } from "react";

import { FormBuilder, Modal } from "shared/components";
import { IAPIState, IFormSchema } from "shared/types";
import { copy } from "shared/assets";
import { User } from "shared/assets/icons";
import { IAuthActions, IUserPatchData } from "Auth/types";
import { useStateActionMeta } from "Auth/utils";
import { makeSchema } from "./formData";

interface ChangeEmailProps {
  title?: string;
  metaKey: IAuthActions;
  oldEmail: string;
  handleClose: () => void;
  onSubmit: ({ email }: IUserPatchData) => void;
}

export const ChangeEmail: React.FC<ChangeEmailProps> = ({
  title = copy.changeEmail.title,
  metaKey,
  oldEmail,
  onSubmit,
  handleClose,
}) => {
  const meta = useStateActionMeta(metaKey);

  const schema: IFormSchema = useMemo(
    () => makeSchema(oldEmail, handleClose),
    [oldEmail, handleClose]
  );

  useEffect(() => {
    if (meta?.status === IAPIState.succeeded) {
      handleClose();
    }
  }, [handleClose, meta]);

  return (
    <Modal icon={User} title={title} data-testid="change_email_modal">
      <FormBuilder
        {...schema}
        onSubmit={onSubmit}
        isSubmitting={meta?.status === IAPIState.pending}
        apiErrorMessage={meta?.error ? (meta?.message ? meta.message.body : true) : false}
        apiError={meta?.error}
      />
    </Modal>
  );
};
